import add from './../../icons/add.svg';
import arrowBigDown from './../../icons/arrow-big-down.svg';
import arrowBigLeft from './../../icons/arrow-big-left.svg';
import arrowBigRight from './../../icons/arrow-big-right.svg';
import arrowBigUp from './../../icons/arrow-big-up.svg';
import arrowMedDown from './../../icons/arrow-med-down.svg';
import arrowMedLeft from './../../icons/arrow-med-left.svg';
import arrowMedRight from './../../icons/arrow-med-right.svg';
import arrowMedUp from './../../icons/arrow-med-up.svg';
import back from './../../icons/back.svg';
import check from './../../icons/check.svg';
import filter from './../../icons/filter.svg';
import find from './../../icons/find.svg';
import gears from './../../icons/gears.svg';
import group from './../../icons/group.svg';
import help from './../../icons/help.svg';
import license from './../../icons/license.svg';
import properties from './../../icons/properties.svg';
import refresh from './../../icons/refresh.svg';
import remove from './../../icons/remove.svg';
import save from './../../icons/save.svg';
import services from './../../icons/services.svg';
import users from './../../icons/users.svg';
import deploy from './../../icons/deploy.svg';
import copy from './../../icons/copy.svg';

const foIcons = {
    add,
    arrowBigDown,
    arrowBigLeft,
    arrowBigRight,
    arrowBigUp,
    arrowMedDown,
    arrowMedLeft,
    arrowMedRight,
    arrowMedUp,
    back,
    check,
    filter,
    find,
    gears,
    group,
    help,
    license,
    properties,
    refresh,
    remove,
    save,
    services,
    users,
    deploy,
    copy
};

const getIconClass = (key) => (foIcons[key] || key);

export {foIcons as default, getIconClass};


// WEBPACK FOOTER //
// ./src/app/utils/icons.js